module.exports = __webpack_public_path__ + "static/media/barcode.20cdb0f8.svg";